$(function() {
	const tickerSlider = new Swiper('.ticker-slider', {
		slidesPerView: 'auto',
		speed: 35000,
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
    },
	});

	const clientsSlider = new Swiper('.clients-slider', {
		slidesPerView: 'auto',
		speed: 20000,
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
    },
	});
})